import { type FooterLevelOneGroup } from '~/interfaces/HeaderFooterNavV2';

import FooterNavGroup from './components/FooterNavGroup';
import styles from './FooterNav.module.css';

export type FooterNavProps = {
  categoryGroups: FooterLevelOneGroup[];
};

const shouldNotShowNav = (categoryLinks: FooterLevelOneGroup[]) => {
  return !!(!categoryLinks || !categoryLinks.length);
};

export function FooterNav({ categoryGroups }: FooterNavProps) {
  if (shouldNotShowNav(categoryGroups)) return null;

  return (
    <section aria-label="Main Footer Nav Section" data-testid="footer-nav-v2">
			<nav
        aria-label="Main Footer Navigation"
        className={styles.footerNavContainer}>

				<div className={styles.footerNavWrapper}>
					<ul className={styles.footerNavGroups}>
						{categoryGroups.
            filter((group) => group.subLinks.length > 0).
            map((props) =>
            <FooterNavGroup key={props.name} {...props} />
            )}
					</ul>
				</div>
			</nav>
		</section>);

}